import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">
            热度榜单
          </h2>
          <span className="text-xs text-foreground-400 whitespace-nowrap">实时更新 · 数据来源站内播放</span>
        </div>
        <div className="max-w-[900px] mx-auto">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 py-3.5 border-b border-background-200/60 last:border-b-0 group cursor-pointer hover:bg-background-50/80 px-3 rounded-lg transition-colors"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-semibold text-foreground-950 truncate">
                  {item.title}
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.type}</div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-sm font-bold text-primary-500 whitespace-nowrap">
                  {item.hot}
                </div>
                <div className={`text-[11px] whitespace-nowrap ${
                  item.trend === 'up' ? 'text-green-600' :
                  item.trend === 'new' ? 'text-accent-500' :
                  'text-foreground-400'
                }`}>
                  {item.change}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}